import moment from "moment";

export default {
  date: (value: Date | string, format: string): string => {
    if (value) {
      if (format) {
        return moment(value).format(format);
      } else {
        return moment(value).format("DD/MM/YYYY");
      }
    }
    return "";
  },
  numberFormat: (value: number = 0): string => {
    return new Intl.NumberFormat().format(value);
  },
};
